module.exports = __WEBPACK_EXTERNAL_MODULE_8__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/Rx","commonjs2":"rxjs/Rx","amd":"rxjs/Rx"}
// module id = 8
// module chunks = 0 1